
const digest = '1afeff54b4f9c8e2377da345fbae0dc6c6916f8ce643f916ca3ebbc3a106b21b';
const classes = {"wrapper":"_wrapper_t8msw_1","checkbox":"_checkbox_t8msw_4","image":"_image_t8msw_12"};
const css = `._wrapper_t8msw_1 {
  position: relative;
}
._wrapper_t8msw_1 ._checkbox_t8msw_4 {
  position: absolute;
  z-index: 1;
  left: 5px;
  top: 5px;
  border: 1px solid #6549f0;
  border-radius: 10px;
}
._wrapper_t8msw_1 ._image_t8msw_12 {
  width: 100%;
  height: 150px;
  border-radius: 15px;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
  display: flex;
  justify-content: flex-end;
  border: 1px solid #d5e2f7;
  object-fit: cover;
  cursor: pointer;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  